import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, UrlTree} from '@angular/router';
import {AuthService} from '@app/auth/services';
import {Observable} from 'rxjs';
import {NEW_PERSONAL_URL, ROUTES} from 'src/utils/constants';
import {getPageRoute, isNewPersonalAreaPage} from "../../../utils/helpers";

@Injectable({
  providedIn: 'root',
})
export class AuthGuardGuard implements CanActivate {
  constructor(private _AuthService: AuthService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = this._AuthService.getToken();
    const pageRoute = getPageRoute();

    if (pageRoute.startsWith(ROUTES.AUTH.AUTH)) {
      const routePart = pageRoute.split('?')[0].split('/').pop();

      this._AuthService.redirectToNewPersonal(routePart);
    }

    if (isNewPersonalAreaPage(pageRoute)) {
      window.location.href = `${NEW_PERSONAL_URL}${pageRoute}`;
    }

    if (!route.routeConfig?.path?.includes('auth')) {
      if (token) {
        return true;
      } else {
        this._AuthService.redirectToNewPersonal();
      }
      return false;
    } else {
      return !token;
    }
  }
}
